module.exports = __webpack_public_path__ + "static/media/notre-dame-tyngsboro.9e1c3c57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/notre-dame-tyngsboro.jpg
// module id = 724
// module chunks = 0